<div class="w-full aligner-start container" *ngIf="state.showValue">
  <div *ngIf="state.isAppend" class="aligner-start">
    <y42-icon [icon]="importIcon" class="job-import incremental"></y42-icon>
    Incremental
  </div>
  <div *ngIf="state.isTruncate" class="aligner-start">
    <y42-icon [icon]="importIcon" class="job-import full"></y42-icon>
    Full
  </div>
</div>
